export function GrapeIcon({ size = 24 }: { size?: number }) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={size}
			height={size}
			viewBox="0 0 35 35"
		>
			<circle cx="13.9" cy="13.5" r="2.5" />
			<circle cx="20.7" cy="13.5" r="2.5" />
			<circle cx="17.4" cy="29.9" r="2.5" />
			<circle cx="20.8" cy="24.7" r="2.5" />
			<circle cx="14" cy="24.7" r="2.5" />
			<circle cx="24.2" cy="19.2" r="2.5" />
			<circle cx="17.5" cy="19.2" r="2.5" />
			<circle cx="10.8" cy="19" r="2.5" />
			<path d="M24 3.4c-.3-.7-1.1-1.1-1.8-.8-.7.3-2.7 1.1-4.1 3-.3.3-.6.9-.8 1.5-.1-1-.5-2.2-1.4-3.1-1.1-1.1-2.7-1.4-3.7-1.5-.2 0-.4.1-.6.2-.2.2-.2.4-.2.6.1 1 .4 2.6 1.5 3.7s2.7 1.4 3.7 1.5h.2c-.1.4-.3.8-.4 1.1-.1.4.2.9.7.9h.8c.3 0 .6-.2.7-.5 1.1-3.3 3.8-4.4 4.7-4.8.7-.3 1-1 .7-1.8z" />
		</svg>
	)
}
